import axios from 'axios';
import api from './api';
import { PaybosConfigInput } from '../types/paybos';

export const paybosConfigAPI = {
  getConfig: async () => {
    const response = await api.get('/paybos/config');
    return response.data;
  },
  toggleEnabled: async (is_enabled: boolean) => {
    const response = await api.patch('/paybos/config/enabled', { is_enabled });
    return response.data;
  },

  updateConfig: async (configData: PaybosConfigInput) => {
    const response = await api.put('/paybos/config', configData);
    return response.data;
  },
};

export const paybosPaymentAPI = {
  createPayment: async (data: {
    bill_id: string;
    customer_data?: { name?: string; email?: string; phone?: string };
    replace_existing?: boolean;
  }) => {
    const response = await api.post('/paybos/create-payment', data);
    return response.data;
  },
  getPaymentDetail: async (id: string) => {
    const response = await api.get(`/paybos/payment/${id}`);
    return response.data;
  },
  checkPaymentStatus: async (id: string) => {
    const response = await api.get(`/paybos/status/${id}`);
    return response.data;
  },
  getBillPayments: async (billId: string) => {
    const response = await api.get(`/paybos/bill/${billId}/payments`);
    return response.data;
  },
};

const publicApiUrl = () => process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

export const publicPaybosAPI = {
  getBillDetail: async (billId: string) => {
    const response = await axios.get(`${publicApiUrl()}/public/paybos/bill/${billId}`);
    return response.data;
  },
  createPayment: async (data: {
    bill_id: string;
    customer_name: string;
    customer_email: string;
    customer_phone?: string;
    replace_existing?: boolean;
  }) => {
    const response = await axios.post(`${publicApiUrl()}/public/paybos/create-payment`, data);
    return response.data;
  },
  checkPaymentStatus: async (id: string) => {
    const response = await axios.get(`${publicApiUrl()}/public/paybos/status/${id}`);
    return response.data;
  },
  getPaymentDetail: async (id: string) => {
    const response = await axios.get(`${publicApiUrl()}/public/paybos/payment/${id}`);
    return response.data;
  },
  checkExistingPayment: async (billId: string) => {
    const response = await axios.get(`${publicApiUrl()}/public/paybos/bill/${billId}/existing-payment`);
    return response.data;
  },
};

export default {
  config: paybosConfigAPI,
  payment: paybosPaymentAPI,
  public: publicPaybosAPI,
};
